
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import ProgramOverviewContent from "@/components/ProgramOverview";
import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";

const ProgramOverview = () => {
  const [isPageLoaded, setIsPageLoaded] = useState(false);

  // Scroll to top when component mounts and trigger animations
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Slight delay to ensure smooth animation entrance
    const timer = setTimeout(() => {
      setIsPageLoaded(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Helmet>
        <title>Program Overview | The Monastery Method™</title>
        <meta name="description" content="Explore The Monastery Method™ program, integrating ancient monastic wisdom into modern leadership for sustainable success and meaning." />
      </Helmet>
      
      <Navbar />
      
      <div className={`pt-24 transition-opacity duration-700 ${isPageLoaded ? 'opacity-100' : 'opacity-0'}`}>
        <div id="program-content" className="content-container">
          <ProgramOverviewContent />
        </div>
      </div>
      <Footer showProgramOverview={false} />
    </>
  );
};

export default ProgramOverview;
